import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import InstallPWA from "./InstallPWA";
import {
  FaPlus,
  FaEdit,
  FaSignOutAlt,
  FaSearch,
  FaBox,
  FaUser,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaSave,
  FaBars,
  FaBuilding,
  FaChevronDown,
  FaCheck,
  FaEllipsisV,
  FaFilter,
  FaTimesCircle,
} from "react-icons/fa";
    import ModernLoader from "./Loader"

const ComboBox = ({
  label,
  value,
  onChange,
  options = [],
  placeholder,
  required = false,
  icon: Icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState(value || "");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setSearchText(value || "");
  }, [value]);

  useEffect(() => {
    if (searchText) {
      const filtered = options.filter((opt) =>
        opt.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  }, [searchText, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setSearchText(val);
    onChange(val);
    setIsOpen(true);
  };

  const handleSelect = (opt) => {
    setSearchText(opt);
    onChange(opt);
    setIsOpen(false);
  };

  const isNewValue = searchText && !options.includes(searchText);

  return (
    <div style={{ marginBottom: "16px" }} ref={wrapperRef}>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: "#374151",
          fontSize: "13px",
          fontWeight: "600",
          marginBottom: "6px",
        }}
      >
        {Icon && <Icon size={14} style={{ color: "#6366f1" }} />}
        {label}
        {required && <span style={{ color: "#ef4444" }}>*</span>}
      </label>

      <div style={{ position: "relative" }}>
        <input
          type="text"
          placeholder={placeholder || `Select or type ${label}`}
          value={searchText}
          onChange={handleInputChange}
          onFocus={() => setIsOpen(true)}
          style={{
            width: "100%",
            padding: "10px 36px 10px 12px",
            border: isNewValue ? "2px solid #10b981" : "2px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "14px",
            backgroundColor: "#fff",
            outline: "none",
            transition: "all 0.2s",
            boxSizing: "border-box",
            color: "#111827",
          }}
          onBlur={(e) => (e.target.style.borderColor = isNewValue ? "#10b981" : "#d1d5db")}
        />

        <FaChevronDown
          size={12}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: `translateY(-50%) rotate(${isOpen ? "180deg" : "0deg"})`,
            color: "#6b7280",
            transition: "transform 0.2s",
            pointerEvents: "none",
          }}
        />

        {isNewValue && (
          <span
            style={{
              position: "absolute",
              top: "-10px",
              right: "10px",
              background: "#10b981",
              color: "white",
              padding: "2px 8px",
              borderRadius: "6px",
              fontSize: "10px",
              fontWeight: "600",
            }}
          >
            + NEW
          </span>
        )}

        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              background: "white",
              border: "2px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
              maxHeight: "220px",
              overflowY: "auto",
              zIndex: 1000,
              marginTop: "4px",
            }}
          >
            {isNewValue && (
              <div
                onClick={() => handleSelect(searchText)}
                style={{
                  padding: "10px 12px",
                  cursor: "pointer",
                  background: "#ecfdf5",
                  borderBottom: "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  color: "#047857",
                  fontSize: "13px",
                  fontWeight: "500",
                }}
              >
                <FaPlus size={11} />
                Add "{searchText}"
              </div>
            )}

            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt, idx) => (
                <div
                  key={idx}
                  onClick={() => handleSelect(opt)}
                  style={{
                    padding: "10px 12px",
                    cursor: "pointer",
                    background: opt === searchText ? "#f3f4f6" : "white",
                    borderBottom: idx < filteredOptions.length - 1 ? "1px solid #f3f4f6" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontSize: "13px",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#f9fafb")}
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = opt === searchText ? "#f3f4f6" : "white")
                  }
                >
                  <span style={{ color: "#374151" }}>{opt}</span>
                  {opt === searchText && <FaCheck size={11} style={{ color: "#6366f1" }} />}
                </div>
              ))
            ) : !isNewValue ? (
              <div style={{ padding: "12px", textAlign: "center", color: "#9ca3af", fontSize: "13px" }}>
                No options found
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default ComboBox;